import { Dispatch, SetStateAction } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { LoginForm } from '../LoginForm/LoginForm';
import { Logo } from '../Logo/Logo';
import styles from './LoginModal.module.scss';

const LoginModalComponent = ({
  isModalOpen,
  setIsModalOpen = () => {},
  redirectTo,
  showCancel = true,
  showSignup = false,
  comesFromPublicShop = false,
  selectedProduct = null,
  navigateAway = true,
  onAuth,
}: {
  isModalOpen: boolean;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
  redirectTo?: string;
  showCancel?: boolean;
  showSignup?: boolean;
  comesFromPublicShop?: boolean;
  selectedProduct?: Object | null;
  navigateAway?: boolean;
  onAuth?: () => any;
}) => {
  const { t } = useTranslation();
  const { isNative } = useCapacitor();

  return (
    <Modal className="tootor-modal" show={isModalOpen} onHide={() => setIsModalOpen(false)} centered={isNative} backdrop={isNative ? 'static' : true} keyboard={!isNative}>
      {isNative && (
        <div className={styles.logoContainer}>
          <Logo className={styles.nativeLogo} />
        </div>
      )}
      <Modal.Header>
        <Modal.Title>{t('loginModal.labels.effettuaAccesso')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoginForm
          redirectTo={redirectTo}
          showCancel={showCancel}
          showSignup={showSignup}
          comesFromPublicShop={comesFromPublicShop}
          selectedProduct={selectedProduct}
          navigateAway={navigateAway}
          onAuth={onAuth}
          onClose={() => setIsModalOpen(false)}
        />
      </Modal.Body>
    </Modal>
  );
};

export { LoginModalComponent as LoginModal };
